import { fetchAction, simpleDispatchAction } from '../utils/actions'
import {
  PROMO_CODE_VALIDATE_REQUESTED,
  PROMO_CODE_VALIDATE_RECIEVED,
  PROMO_CODE_VALIDATE_FAILED,
  PROMO_CODE_VALIDATE_CLEAR
} from '../utils/constants'

export function validatePromoCode(code) {
  return fetchAction({
    shouldCallAPI: () => true,
    requestParams: { method: 'GET', url: '/promo_codes/valid', qs: { code } },
    requestAction:  ()     => ({ type: PROMO_CODE_VALIDATE_REQUESTED, code }),
    receivedAction: (data) => ({ type: PROMO_CODE_VALIDATE_RECIEVED,  valid: data.valid }),
    failureAction:  (err)  => ({ type: PROMO_CODE_VALIDATE_FAILED,    error: err })
  })
}

export function clearPromoCodeValidation() {
  return simpleDispatchAction({ action: () => ({ type: PROMO_CODE_VALIDATE_CLEAR }) })
}
